module.exports = __webpack_public_path__ + "static/media/bell-alarm1.bf88fa5b.aac";